import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  MY_ORGANIZATION_FEATURE_KEY,
  MyOrganizationState,
  myOrganizationAdapter,
} from './my-organization.reducer';

// Lookup the 'MyOrganization' feature state managed by NgRx
export const getMyOrganizationState = createFeatureSelector<MyOrganizationState>(
  MY_ORGANIZATION_FEATURE_KEY
);

const { selectAll, selectEntities } = myOrganizationAdapter.getSelectors();

export const GetUsersList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.usersList
);
export const GetManageTeams = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.manageTeamsData
);

export const GetDeleteManageData = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.deleteManageData
);

export const GetprojectWorkflowList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.projectWorkflowList
);

export const GetPaymentTransactionList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.paymentTransactionList
);

export const GetManageScenarioWorkflowList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.manageScenarioWorkflow
);

export const GetProductGroupsList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.productGroupsList
);

export const GetSuppliersList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.suppliersList
);

export const GetlitterImpactData = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.litterImpactData
);

export const GetyearEndsOnData = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.yearEndsOnData
);

export const GetyearEndsOnDataReplica = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.yearEndsReplica
);

export const GetCustomCategoryData = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.customCategoryData
);

export const GetCustomSpeedosData = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.customSpeedosData
);

export const GetPackagingMetricsData = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.packagingMetricsData
);

export const GetProjectSavingLogsData = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.projectSavingLogsData
);

export const GetSSOGroupList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.ssoGroupList
);

export const GetUserDetailList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.manageUserDetailsData
);

export const GetTeamMembershipList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.manageTeamMembershipData
);

export const GetAdminOrganizationMembershipDataList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.adminOrganizationMembershipData
);

export const GetTeamDetailList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.manageTeamData
);

export const GetInvoiceDataList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.invoiceData
);

export const GetInvoiceDownloadData = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.invoiceDownloadData
);

export const GetWeightingList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.weightingList
);

export const addSKUYear = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.skuYearProcess
);

export const GetSKUYearError = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.skuYearProcessError
);

export const GetOrgWeightingDataList = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.orgWeightingData
);

export const checkUpdateActionSKUSelector = createSelector(
  getMyOrganizationState,
  (state: MyOrganizationState) => state.checkUpdateActionSKU
);
